import { IsNotEmpty, IsString } from 'class-validator';

export class DeleteUserAssetDto {
    @IsString()
    @IsNotEmpty()
    readonly assetId!: string;
}
